import React from "react";
import * as Sentry from "@sentry/react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

Sentry.init({
  dsn: "https://228dac304215d869466920a60022dbdb@o4506798074232832.ingest.us.sentry.io/4512249392201728",
  environment: process.env.REACT_APP_APP_ENV,

  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Capture 100% of transactions for tracing.
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Only propagate trace headers to same-origin requests; add the TamTam API
  // (e.g. /^https:\/\/api\.tamtam\.pro/) once its CORS allows sentry-trace/baggage.
  tracePropagationTargets: [/^\//],
});
